/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ResolveChatIdentitiesResponse = zod.object({
  links: zod
    .array(
      zod.object({
        actorUuid: zod.uuid().describe('The OE actor'),
        reachUserId: zod
          .string()
          .describe('Reach users.id — for a GROUP, the service user standing for it'),
      }),
    )
    .describe(
      'One link per resolvable actor. Invisible and unmapped targets are both simply absent — one shape, no probe.',
    ),
});

export type ResolveChatIdentitiesResponse = zod.input<typeof ResolveChatIdentitiesResponse>;
export type ResolveChatIdentitiesResponseOutput = zod.output<typeof ResolveChatIdentitiesResponse>;
